import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MuiBannerModule } from '@move/ui';
import { TranslateModule } from '@ngx-translate/core';
import { MmuBrowserSupportBanner } from './mmu-browser-support-banner/mmu-browser-support-banner.component';



@NgModule({
  declarations: [
    MmuBrowserSupportBanner
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MuiBannerModule
  ],
  exports: [
    MmuBrowserSupportBanner
  ]
})
export class MmuBrowserSupportModule { }
